module.exports = new __parcel__URL__("animegirl-screenshot.379b2495.jpg").toString();